<div>
  <p class="list-title">{{ data.title }}</p>

  <ul *ngIf="data.list && data.list.length">
    <li *ngFor="let el of data.list | sortBy: 'asc':'order'">{{ el.text }}</li>
  </ul>
</div>
